import { ErrorPacket, Next, Pipe } from '../types';
import { ErrorConverterService } from '../../services/error-converter.service';
import { IJsonApiErrorDocument } from '../../services/jsonapi-error.interface';

export class JsonApiErrorPipe implements Pipe<ErrorPacket, ErrorPacket> {
    public constructor(private readonly errorConverter: ErrorConverterService) {}

    public handle(packet: ErrorPacket, next: Next<ErrorPacket, ErrorPacket>): ErrorPacket {
        if (packet.result) return next(packet);

        const error: IJsonApiErrorDocument = packet.data as IJsonApiErrorDocument;

        if (!error?.errors || !Array.isArray(error.errors)) {
            return next(packet);
        }

        return {
            ...packet,
            result: this.errorConverter.getAppErrorFromJsonApi(error),
        };
    }
}
